import React from 'react';

export default function Container({
  children,
  isFeedback = false,
  feedback,
}: {
  children: React.ReactNode;
  isFeedback?: unknown;
  feedback?: React.ReactNode;
}) {
  if (isFeedback) {
    return feedback;
  }
  return children;
}
